import { Response } from '@marketplace-web/core-api/api-client-util'

import {
  ShippingInstructionsDto,
  ShippingInstructionsCarrierDto,
  ShippingInstructionsModel,
  ShippingInstructionsCarrierModel,
  GetShippingInstructionsResp,
} from '../types/shipping-instructions'

export const transformShippingInstructionsCarrierDto = (
  shippingInstructionsCarrier: ShippingInstructionsCarrierDto,
): ShippingInstructionsCarrierModel => ({
  name: shippingInstructionsCarrier.name,
  iconUrl: shippingInstructionsCarrier.icon_url,
})

export const transformShippingInstructionsDto = (
  shippingInstructions: ShippingInstructionsDto,
): ShippingInstructionsModel => ({
  id: shippingInstructions.id,
  carrier: transformShippingInstructionsCarrierDto(shippingInstructions.carrier),
  instructions: shippingInstructions.instructions,
})

export const transformShippingInstructionsResponse = (
  response: Response<GetShippingInstructionsResp>,
) => transformShippingInstructionsDto(response.shipping_instructions)
